var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatisticsTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 21,
    fill: "#E6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 32.75C16.76 32.75 12.5 28.49 12.5 23.25C12.5 18.01 16.76 13.75 22 13.75C27.24 13.75 31.5 18.01 31.5 23.25C31.5 28.49 27.24 32.75 22 32.75ZM22 15.25C17.59 15.25 14 18.84 14 23.25C14 27.66 17.59 31.25 22 31.25C26.41 31.25 30 27.66 30 23.25C30 18.84 26.41 15.25 22 15.25Z",
    fill: "#26B5ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23.75C21.59 23.75 21.25 23.41 21.25 23V18C21.25 17.59 21.59 17.25 22 17.25C22.41 17.25 22.75 17.59 22.75 18V23C22.75 23.41 22.41 23.75 22 23.75Z",
    fill: "#26B5ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12.75H19C18.59 12.75 18.25 12.41 18.25 12C18.25 11.59 18.59 11.25 19 11.25H25C25.41 11.25 25.75 11.59 25.75 12C25.75 12.41 25.41 12.75 25 12.75Z",
    fill: "#26B5ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsTime);
export default __webpack_public_path__ + "static/media/statistics-time.0dd684579a8e5591f17734d0e761a41f.svg";
export { ForwardRef as ReactComponent };